<template>
  <div class="">
    <div>
      <BrandingForm />
    </div>

    <!-- <div class="w-3/5">
      <BrandingGallery :key="componentKey" />
    </div> -->
  </div>
</template>
<script>
import BrandingForm from "./BrandingForm.vue";
import BrandingGallery from "./BrandingGallery.vue";
import { mapState } from "vuex";

export default {
  components: {
    BrandingForm,
    BrandingGallery,
  },

  data() {
    return {
      componentKey: 0,
    };
  },

  computed: {
    ...mapState("brandProfile", ["brandProfile", "layoutSelected"]),
  },

  watch: {
    layoutSelected() {
      this.componentKey += 1;
    },
  },
};
</script>
